// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"98a08090","513":"00774f92","787":"3f17209f"}[chunkId] + ".chunk.js";
};